import React, {useEffect, useState, Suspense} from 'react'
import styles from './styles.css'
import Message from './Message'
import useRef from 'App/hooks/useRef'
import Typing from './Typing'
import moment from 'moment'
import System from './System'
import Loading from './Loading'
import useOnEvent from 'App/helpers/globalEvents/useOnEvent'
import MessagesFromPastConversations from './MessagesFromPastConversations'

export function ChatMessage({message, readByVehicleAt}) {
  if (message.isSystemMessage) return <System key={message._id} message={message} />

  const isRead = moment(message.date).isBefore(readByVehicleAt)
  return <Message key={message._id} isRead={isRead} message={message} />
}

export default function Messages({conversation, messages, lastEndedConversations}) {
  const container = useRef()
  const [pendingMessages, setPendingMessages] = useState([])

  useOnEvent('messageSent', ({_id, text, image, conversationId: messageConversationId}) => {
    if (!conversation || conversation._id !== messageConversationId) return
    setPendingMessages(array => [...array, {_id, date: new Date(), image, text}])
  })

  useEffect(() => {
    setPendingMessages([])
  }, [conversation && conversation.lastActivityAt])

  const scrollToBottom = () => {
    container.current.scrollTop = container.current.scrollHeight
  }

  useEffect(() => {
    scrollToBottom()
  }, [
    pendingMessages.length,
    messages && messages.length,
    conversation && conversation.isVehicleTyping
  ])

  const displayMessages = (messages || []).filter(
    message => !pendingMessages.map(({_id}) => _id).includes(message._id)
  )

  return (
    <div
      className={styles.container}
      ref={container}>
      {conversation ? (
        <Suspense fallback={<Loading />}>
          <MessagesFromPastConversations
            onLoad={scrollToBottom}
            conversationIds={lastEndedConversations
              .filter(({closedAt}) =>
                moment(closedAt).isBefore(moment(conversation.lastActivityAt))
              )
              .map(({_id}) => _id)
              .filter(id => id !== conversation._id)}
          />
        </Suspense>
      ) : null}

      {displayMessages ? (
        displayMessages.map(message => (
          <ChatMessage
            key={message._id}
            message={message}
            readByVehicleAt={conversation.readByVehicleAt}
          />
        ))
      ) : (
        <Loading />
      )}
      {pendingMessages.map((message, index) => (
        <Message key={index} message={message} sending />
      ))}
      {conversation && conversation.isVehicleTyping ? <Typing /> : null}
    </div>
  )
}
